






import { computed, defineComponent, useRouter } from '@nuxtjs/composition-api';

import { useAuthentication } from '@/hooks/useAuthentication';

export default defineComponent({
  head: {
    title: 'Login | Built In',
  },
  setup: (_, ctx) => {
    const { isAuthenticated, signin } = useAuthentication();
    const router = useRouter();

    const destination = computed(() => {
      const queryDest = ctx.root.$route.query.destination;
      const dest = (Array.isArray(queryDest) && queryDest.length > 1 ? queryDest[0] : queryDest) as
        | string
        | null;
      return dest || '/';
    });

    if (!isAuthenticated.value) {
      signin(destination.value);
    } else {
      /**
       * Check if it's a Vue route, and if it's not, change the location using window object.
       * This is a workaround for OAK-3619
       */

      const resolvedRoute = router.resolve(destination.value);

      if (resolvedRoute.route.matched.length > 0) {
        router.replace(destination.value);
      } else {
        window.location.href = destination.value;
      }
    }
  },
});
